/**
 * valumize API for creating reports
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { DocumentMetadata } from '../model/document-metadata';
// @ts-ignore
import { GenerateDocumentRequest } from '../model/generate-document-request';
// @ts-ignore
import { TaskInfoIdResponse } from '../model/task-info-id-response';
// @ts-ignore
import { TemplateInfo } from '../model/template-info';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class ReportApiService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (Array.isArray(basePath) && basePath.length > 0) {
                basePath = basePath[0];
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Start async generation of a document from a template
     * Registers an async task to generate a document for the given context and IDs. Returns the task id immediately; on completion the user receives a JOB_FINISHED notification carrying a download link to the persisted document. 
     * @param generateDocumentRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public generateDocument(generateDocumentRequest: GenerateDocumentRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<TaskInfoIdResponse>;
    public generateDocument(generateDocumentRequest: GenerateDocumentRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<TaskInfoIdResponse>>;
    public generateDocument(generateDocumentRequest: GenerateDocumentRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<TaskInfoIdResponse>>;
    public generateDocument(generateDocumentRequest: GenerateDocumentRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (generateDocumentRequest === null || generateDocumentRequest === undefined) {
            throw new Error('Required parameter generateDocumentRequest was null or undefined when calling generateDocument.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/documents/generate`;
        return this.httpClient.request<TaskInfoIdResponse>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: generateDocumentRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets all project reports
     * Returns all project reports
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllProjectReports(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<DocumentMetadata>>;
    public getAllProjectReports(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<DocumentMetadata>>>;
    public getAllProjectReports(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<DocumentMetadata>>>;
    public getAllProjectReports(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/deals/reports/projectReport`;
        return this.httpClient.request<Array<DocumentMetadata>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets the requested report for the given deal
     * Returns the generated report for the given deal
     * @param projectName The name of the project
     * @param dealIds The deals for which the project report should be created.
     * @param projectClosingDate The closing date of the project
     * @param firstRoundOffersDeadline The closing date of the project
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getProjectReport(projectName: string, dealIds: Array<number>, projectClosingDate?: string, firstRoundOffersDeadline?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*', context?: HttpContext}): Observable<Blob>;
    public getProjectReport(projectName: string, dealIds: Array<number>, projectClosingDate?: string, firstRoundOffersDeadline?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*', context?: HttpContext}): Observable<HttpResponse<Blob>>;
    public getProjectReport(projectName: string, dealIds: Array<number>, projectClosingDate?: string, firstRoundOffersDeadline?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*', context?: HttpContext}): Observable<HttpEvent<Blob>>;
    public getProjectReport(projectName: string, dealIds: Array<number>, projectClosingDate?: string, firstRoundOffersDeadline?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*', context?: HttpContext}): Observable<any> {
        if (projectName === null || projectName === undefined) {
            throw new Error('Required parameter projectName was null or undefined when calling getProjectReport.');
        }
        if (dealIds === null || dealIds === undefined) {
            throw new Error('Required parameter dealIds was null or undefined when calling getProjectReport.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (projectName !== undefined && projectName !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>projectName, 'projectName');
        }
        if (dealIds) {
            dealIds.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'dealIds');
            })
        }
        if (projectClosingDate !== undefined && projectClosingDate !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>projectClosingDate, 'projectClosingDate');
        }
        if (firstRoundOffersDeadline !== undefined && firstRoundOffersDeadline !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>firstRoundOffersDeadline, 'firstRoundOffersDeadline');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                '*/*'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let localVarPath = `/api/deals/reports/projectReport/template`;
        return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List templates applicable to a context (including broader parents)
     * Returns all template definitions applicable to the requested &#x60;context&#x60; **and** its broader parent contexts (least to most specific). For example, if &#x60;context&#x3D;FUND_WITH_SELLER_POSITION&#x60;, templates for the following contexts are included: &#x60;FUND&#x60;, &#x60;FUND_WITH_REPORT&#x60;, &#x60;FUND_WITH_VALUATION&#x60;, and &#x60;FUND_WITH_SELLER_POSITION&#x60;. Note: the &#x60;idsByType&#x60; map in each &#x60;TemplateInfo&#x60; is intentionally empty in this listing response. 
     * @param context The most specific context you are in; results include templates for this context **and** all broader parent contexts.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTemplates(context: 'DEAL_OVERVIEW' | 'DEAL' | 'FUND' | 'FUND_WITH_REPORT' | 'FUND_WITH_VALUATION' | 'FUND_WITH_VALUATION_BOTTOM_UP' | 'FUND_WITH_VALUATION_TOP_DOWN' | 'FUND_WITH_SELLER_POSITION' | 'ASSET' | 'ASSET_WITH_REPORT' | 'ASSET_WITH_VALUATION' | 'GENERAL_PARTNER', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<TemplateInfo>>;
    public getTemplates(context: 'DEAL_OVERVIEW' | 'DEAL' | 'FUND' | 'FUND_WITH_REPORT' | 'FUND_WITH_VALUATION' | 'FUND_WITH_VALUATION_BOTTOM_UP' | 'FUND_WITH_VALUATION_TOP_DOWN' | 'FUND_WITH_SELLER_POSITION' | 'ASSET' | 'ASSET_WITH_REPORT' | 'ASSET_WITH_VALUATION' | 'GENERAL_PARTNER', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<TemplateInfo>>>;
    public getTemplates(context: 'DEAL_OVERVIEW' | 'DEAL' | 'FUND' | 'FUND_WITH_REPORT' | 'FUND_WITH_VALUATION' | 'FUND_WITH_VALUATION_BOTTOM_UP' | 'FUND_WITH_VALUATION_TOP_DOWN' | 'FUND_WITH_SELLER_POSITION' | 'ASSET' | 'ASSET_WITH_REPORT' | 'ASSET_WITH_VALUATION' | 'GENERAL_PARTNER', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<TemplateInfo>>>;
    public getTemplates(context: 'DEAL_OVERVIEW' | 'DEAL' | 'FUND' | 'FUND_WITH_REPORT' | 'FUND_WITH_VALUATION' | 'FUND_WITH_VALUATION_BOTTOM_UP' | 'FUND_WITH_VALUATION_TOP_DOWN' | 'FUND_WITH_SELLER_POSITION' | 'ASSET' | 'ASSET_WITH_REPORT' | 'ASSET_WITH_VALUATION' | 'GENERAL_PARTNER', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (context === null || context === undefined) {
            throw new Error('Required parameter context was null or undefined when calling getTemplates.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (context !== undefined && context !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>context, 'context');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/templates`;
        return this.httpClient.request<Array<TemplateInfo>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
